import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

const SameStoreForm = ({ handleSubmit, pristine, submitting, valid }) => (
  <form onSubmit={handleSubmit}>
    <div className="row">
      <div className="col-xs-12 col-sm-7">
        <Field
          name="giftGiverName"
          type="text"
          id="gift-giver-name"
          component={RenderField}
          validate={[Validations.REQUIRED]}
          required
          placeholder="Your First and Last Name"
        />
        <Field
          name="giftGiverEmail"
          type="email"
          id="gift-giver-email"
          component={RenderField}
          validate={[Validations.REQUIRED, Validations.EMAIL]}
          required
          placeholder="Your email"
        />
      </div>
    </div>

    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} className="btn btn-primary btn-wide" value="finish" />
    </div>

    <div className="padding-top">
      <small className="text-muted">Your email is used to help the couple with gift tracking and your personal information is secure. You can learn more about this in our <a href="/privacy" target="_blank" rel="noreferrer noopener">privacy policy</a></small>
    </div>
  </form>
);


SameStoreForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  initialValues: {
    giftGiverName: state.external.giftGiverName,
    giftGiverEmail: state.external.giftGiverEmail
  }
});

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'sameStoreForm'
})(SameStoreForm));



// WEBPACK FOOTER //
// ./src/components/registryitem/SameStoreForm.jsx